interface TCalculateORP{
    srp: number;
    orp: number;
    id: string;
    isORPUpdate: boolean;
    isSRPUpdate: boolean;
    toggleProductOrp:boolean;
}

export const useProduct = () => {
    const calculateORP = ({
        srp,
        orp,
        id,
        isORPUpdate,
        isSRPUpdate,
        toggleProductOrp
    }:TCalculateORP): number => {
        if(!toggleProductOrp) return srp

        // In case of Add the product 
        if (!id) return orp ?? srp;
    
        // If ORP was updated, prioritize returning ORP
        if (isORPUpdate) return orp;
    
        // If SRP was updated, return SRP
        if (isSRPUpdate) return srp;
    
        // Default to returning ORP
        return orp ?? srp;
    };
    

    return {
        calculateORP,
    };
};
